import React, { Component } from 'react'
import { DialogTitle, Dialog as DialogUI, Button, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';

export default class Dialog extends Component {

  // static props = {
  //   dialog: {
  //     open: false
  //   }
  // }
  state = {
    open: false,
  }

  // static getDerivedStateFromProps(props, state) {
  //   console.log(props, state);
    
  //   if (props.dialog.show)
  //     return { ...state, open: props.dialog.show }
  //   return null;
  // }

  // componentDidMount() {
  //   console.log('dialog mount');

  // }

  handleClose = (ops) => {
    // console.log(ops);
    this.setState({open: false})
    this.props.onClose(ops);
  }

  render() {
    const { dialog } = this.props;
    // console.log(dialog);
    const options = dialog.options ? [].concat(dialog.options).reverse() : [];
    return (
      <div>
        <DialogUI
          open={dialog.show ? dialog.show : false}
          // open={this.state.open}
          onClose={() => this.handleClose(0)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{dialog.title || ''}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {dialog.body}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {options.map((option, i) => (
              <Button key={i} onClick={() => this.handleClose(options.length - i)} color="primary">
                {option}
              </Button>
            ))}
            {/* <Button onClick={this.handleClose} color="primary">
              OPCIÓN 2
            </Button>
            <Button onClick={this.handleClose} color="primary" autoFocus>
              OPCIÓN 1 
            </Button>*/}
          </DialogActions>
        </DialogUI>
      </div>
    )
  }
}
